import { OrientationType } from "../constant/assetConstants";
import { AssetPublishModel } from "../models/assetModel";

export interface LayoutBox {
    left: number;
    top: number;
    width: number;
    height: number;
    asset: AssetPublishModel;
}

interface JustifiedLayoutConfig {
    containerWidth: number;
    targetRowHeight: number;
    margin: number;
    leftOffset?: number
}

export function getAssetRatio(
    img: AssetPublishModel
): number {
    //note: default ratio is 4:3
    const imageWidth =
        img.width === undefined || img.width == null || img.width == 0
            ? img.imageOrientation.toUpperCase() === OrientationType.HORIZONTAL.toUpperCase()
                ? 4
                : 3
            : img.width;

    const imageHeight =
        img.height === undefined || img.height == null || img.height == 0
            ? img.imageOrientation.toUpperCase() === OrientationType.HORIZONTAL.toUpperCase()
                ? 3
                : 4
            : img.height;

    const aspectRatio = imageWidth / imageHeight;

    return aspectRatio;
}

export function calculateJustifiedLayout(
    images: AssetPublishModel[],
    config: JustifiedLayoutConfig
): LayoutBox[] {
    const { containerWidth, targetRowHeight, margin, leftOffset = 0 } = config;
    const layout: LayoutBox[] = [];

    let currentRow: AssetPublishModel[] = [];
    let aspectSum = 0;

    const allRows: AssetPublishModel[][] = [];

    for (let index = 0; index < images.length; index++) {
        const img = images[index];
        const aspect = getAssetRatio(img);
        currentRow.push(img);
        aspectSum += aspect;

        const totalMargin = margin * (currentRow.length - 1);
        const rowWidth = targetRowHeight * aspectSum + totalMargin;
        const isLastImage = index === images.length - 1;

        if (rowWidth >= containerWidth || isLastImage) {
            if (isLastImage &&
                allRows.length > 0 &&
                containerWidth > 360 &&
                currentRow.length <= 3
            ) {
                const prevRow = allRows.pop()!;
                prevRow.push(...currentRow);
                allRows.push(prevRow);
            } else {
                allRows.push(currentRow);
            }

            currentRow = [];
            aspectSum = 0;
        }
    }

    let yOffset = 0;
    const isSingleShortRow =
        containerWidth > 1000 &&
        allRows.length === 1 &&
        allRows[0].length <= 4;

    for (const row of allRows) {
        const aspectSum = row.reduce((sum, img) => sum + getAssetRatio(img), 0);
        const totalMargin = margin * (row.length - 1);

        const effectiveHeight = isSingleShortRow
            ? 250
            : targetRowHeight;

        const scale = isSingleShortRow
            ? 1
            : (containerWidth - totalMargin) / (targetRowHeight * aspectSum);

        let xOffset = 0;

        for (const img of row) {
            const ratio = getAssetRatio(img);
            const w = ratio * effectiveHeight * scale;
            const h = effectiveHeight * scale;

            layout.push({
                left: xOffset + leftOffset,
                top: yOffset,
                width: w,
                height: h,
                asset: img
            });

            xOffset += w + margin;
        }

        yOffset += effectiveHeight * scale + margin;
    }

    return layout;
}